import { render, staticRenderFns } from "./TagAgents.vue?vue&type=template&id=1f70c878&scoped=true&"
import script from "./TagAgents.vue?vue&type=script&lang=js&"
export * from "./TagAgents.vue?vue&type=script&lang=js&"
import style0 from "./TagAgents.vue?vue&type=style&index=0&id=1f70c878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70c878",
  null
  
)

export default component.exports